import { render, staticRenderFns } from "./SalesInformation.vue?vue&type=template&id=0d8c721d&scoped=true&"
import script from "./SalesInformation.vue?vue&type=script&lang=ts&"
export * from "./SalesInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SalesInformation.vue?vue&type=style&index=0&id=0d8c721d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c721d",
  null
  
)

export default component.exports